import { useState } from "react";
import type { JSX, PropsWithChildren } from "react";
import type { ExportValueSettings } from "../../../common/export/exportTypes.ts";
import { ExportStateContext } from "./ExportStateContext.ts";

interface Props {
  valueSettings?: ExportValueSettings;
  disabled?: boolean;
}

export const ExportStateContextProvider = ({
  children,
  valueSettings,
  disabled,
}: PropsWithChildren<Props>): JSX.Element => {
  const [container, setContainer] = useState<HTMLElement | null>(null);
  return (
    <ExportStateContext value={{ container, setContainer, valueSettings, disabled }}>{children}</ExportStateContext>
  );
};
